"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlobBalanceEquation = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../shared/core");
var components_1 = require("../../../../../../../shared/core/components");
var copy_1 = require("../../../../../copy");
var BalanceSection_styled_1 = require("./BalanceSection.styled");
var scrollTo = function (id) {
    var element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};
var BlobBalanceEquation = function (_a) {
    var opening = _a.opening, charges = _a.charges, payments = _a.payments, closing = _a.closing;
    var _b = (0, core_1.useComponents)(), Icon = _b.Icon, P = _b.P, TextLink = _b.TextLink;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(BalanceSection_styled_1.StyledBlobBalanceEquation, null,
        react_1.default.createElement(components_1.InfoBlob, { label: react_1.default.createElement(Copy, { copyKey: "balanceSectionOpeningHeading" }), value: opening, status: "info", "data-testid": "info-blob-opening" }),
        react_1.default.createElement(Icon, { name: "minus" }),
        react_1.default.createElement(components_1.InfoBlob, { label: react_1.default.createElement(Copy, { copyKey: "balanceSectionChargesHeading" }), value: { value: charges }, status: "warning", "data-testid": "info-blob-charges" },
            react_1.default.createElement(P, null,
                react_1.default.createElement(TextLink, { href: "#charges", onClick: function () { return scrollTo('charges'); } },
                    react_1.default.createElement(Copy, { copyKey: "balanceSectionChargesDetails" })))),
        react_1.default.createElement(Icon, { name: "plus" }),
        react_1.default.createElement(components_1.InfoBlob, { label: react_1.default.createElement(Copy, { copyKey: "balanceSectionPaymentsHeading" }), value: { value: payments }, status: "primary", "data-testid": "info-blob-payments" },
            react_1.default.createElement(P, null,
                react_1.default.createElement(TextLink, { href: "#payments", onClick: function () { return scrollTo('payments'); } },
                    react_1.default.createElement(Copy, { copyKey: "balanceSectionPaymentsDetails" })))),
        react_1.default.createElement(Icon, { name: "equals" }),
        react_1.default.createElement(components_1.InfoBlob, { label: react_1.default.createElement(Copy, { copyKey: "balanceSectionClosingHeading" }), value: closing, status: "info", "data-testid": "info-blob-closing" })));
};
exports.BlobBalanceEquation = BlobBalanceEquation;
